import { useNavigate } from 'react-router-dom'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { semantic } from 'styles/tokens'

import Logo from 'components/ui/logo'

interface NotFoundProps {
  /** Para onde o botao leva (inicio do painel de quem esta logado). */
  homePath: string
}

/** Pagina inexistente dentro do backoffice ou do captador. */
export default function NotFound({ homePath }: NotFoundProps) {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        mx: 2,
        py: { xs: 6, md: 10 },
        px: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 2,
        backgroundColor: semantic.surface,
        border: `1px solid ${semantic.border}`,
        borderRadius: 3
      }}
    >
      <Logo layout='simbolo' height={56} alt='' />
      <Typography variant='h5' component='h1'>
        Página não encontrada
      </Typography>
      <Typography color='text.secondary' maxWidth={420}>
        O endereço pode ter mudado ou não existe mais. Volte ao início e siga
        pelo menu.
      </Typography>
      <Button variant='contained' onClick={() => navigate(homePath)}>
        Voltar ao início
      </Button>
    </Box>
  )
}
